/**
 * A global namespace for 'transitionend' string.
 */
const transitionEndEvent = 'transitionend';
export default transitionEndEvent;
